export const LAST_UPDATE = "09 Ekim 2026, 12:09";
